export class ApplicationVersion {

    id!: number | null
    critical!: boolean
    platform!: number
    version!: string

}